var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c("div", { staticStyle: { display: "none" } }, [
        _c("iframe", {
          ref: "ssoIframe",
          attrs: { src: _vm.sso + "/?is_staff=1" },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }